import { http } from 'utils'
import { SET_ITEMS, ADD_ITEMS } from 'vx/mutations'
import { concat } from 'lodash'

export default {
  namespaced: true,

  state: {
    ellipsePayrolls: []
  },

  actions: {
    async getPayrolls ({ commit }, { params = {} } = {}) {
      const response = await http.get('lists/ellipse-payrolls')

      commit(ADD_ITEMS, response.data.data.map(item => {
        return {
          id: item,
          name: item
        }
      }))

      return response
    }
  },

  mutations: {
    [SET_ITEMS] (state, items) {
      state.ellipsePayrolls = items
    },

    [ADD_ITEMS] (state, items) {
      state.ellipsePayrolls = concat(state.ellipsePayrolls, items)
    }
  }
}
